import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';
import { inject } from '@angular/core';

import { MijnKanaalconfiguratieService } from '@ap/mijn-kanaalconfiguratie';

import { OperationalCheckConfig } from '../models/operational-check.model';

@Injectable({
    providedIn: 'root'
})
export class OperationalCheckService {
    private readonly mijnKanaalconfiguratieService = inject(MijnKanaalconfiguratieService);

    public isOperational = signal<boolean | null>(null);

    public checkIsOperational(config: OperationalCheckConfig): Observable<boolean> {
        return this.mijnKanaalconfiguratieService.getBooleanConfiguration(config.channelName, config.configKey, false).pipe(
            timeout(10000),
            catchError(() => of(false)),
            tap((isOperational: boolean) => {
                this.isOperational.set(isOperational);
            })
        );
    }

    public reset(): void {
        this.isOperational.set(null);
    }
}
